import axios from 'axios'
const timeout = process.env.REACT_APP_AXIOS_TIME_OUT

export const instance = axios.create({
  timeout: parseInt(timeout)
}
)
